import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getAgentMgrList() {
    return axios.get(`${baseUrl}/ip-scan/get-agent-mgr-list.do`);
  },
  getAgentManagerIdByObjId(objId) {
    return axios.get(`${baseUrl}/ip-scan/get-agent-manager-id-by-obj-id.do`, { params: { objId } });
  },
  getAgentStatusInfo(agentManagerId) {
    return axios.get(`${baseUrl}/ip-scan/get-agent-status-info.do`, { params: { agentManagerId } });
  },
  executeScan(params) {
    return axios.post(`${baseUrl}/ip-scan/execute-${params.tabName}-scan.do`, params);
  },
  resetConnectionStatus(agentManagerId) {
    return axios.get(`${baseUrl}/ip-scan/reset-connection-status.do`, { params: { agentManagerId } });
  },
};



// WEBPACK FOOTER //
// ./src/api/ip-scan.js